import { render, staticRenderFns } from "./BuyRecordsIndex.vue?vue&type=template&id=23e545ae&scoped=true"
import script from "./BuyRecordsIndex.vue?vue&type=script&lang=js"
export * from "./BuyRecordsIndex.vue?vue&type=script&lang=js"
import style0 from "./BuyRecordsIndex.vue?vue&type=style&index=0&id=23e545ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e545ae",
  null
  
)

export default component.exports